module.exports = __webpack_public_path__ + "img/SuperPetNew.0be67b62.png";